(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2013,93812],{

/***/ 90704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Cards_Card; }
});

;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
function extends_() {
  extends_ = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return extends_.apply(this, arguments);
}

function _extends() {
  return extends_.apply(this, arguments);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./components/BlogCommon/Article/ContentfulParser/index.jsx
var ContentfulParser = __webpack_require__(92870);
// EXTERNAL MODULE: ./UI/components/Illustration/index.jsx + 1 modules
var Illustration = __webpack_require__(93812);
// EXTERNAL MODULE: ./UI/components/Typography/index.jsx
var Typography = __webpack_require__(59654);
// EXTERNAL MODULE: ./UI/components/Typography/utils/useTypography.js
var useTypography = __webpack_require__(18422);
// EXTERNAL MODULE: ./UI/containers/CardContainer/index.jsx + 1 modules
var CardContainer = __webpack_require__(35565);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/components/LinkWrapper/index.jsx + 2 modules
var LinkWrapper = __webpack_require__(56362);
// EXTERNAL MODULE: ./UI/containers/Overlay/index.jsx + 1 modules
var Overlay = __webpack_require__(81101);
// EXTERNAL MODULE: ./UI/components/Cards/OverlapCard/OverlapCard.module.scss
var OverlapCard_module = __webpack_require__(42070);
var OverlapCard_module_default = /*#__PURE__*/__webpack_require__.n(OverlapCard_module);
;// CONCATENATED MODULE: ./UI/components/Cards/OverlapCard/index.jsx











var hasTextContent = function(text) {
    var ref;
    if (!text) {
        return false;
    }
    if (typeof text === "string") {
        return Boolean(text.trim());
    }
    return Boolean(text === null || text === void 0 ? void 0 : (ref = text.content) === null || ref === void 0 ? void 0 : ref.length);
};
var OverlapCard = function(param) {
    var className = param.className, image = param.image, title = param.title, text = param.text, description = param.description, url = param.url;
    if (!(image === null || image === void 0 ? void 0 : image.url)) {
        return null;
    }
    var hasHoverContent = Boolean(title || description || hasTextContent(text));
    var Wrapper = url ? LinkWrapper/* default */.Z : "div";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, url && {
        path: url
    }), {
        className: classnames_default()((OverlapCard_module_default()).overlapCard, className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                className: (OverlapCard_module_default()).image,
                src: image.url,
                alt: image.alt || title || "",
                transparent: true
            }),
            hasHoverContent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Overlay/* default */.Z, {
                className: (OverlapCard_module_default()).overlay,
                children: [
                    title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                        variant: useTypography/* TYPOGRAPHY_TAGS.h3 */.w1.h3,
                        size: useTypography/* TYPOGRAPHY_SIZE.headline20 */.y3.headline20,
                        isBold: true,
                        children: title
                    }),
                    (hasTextContent(text) || description) && (text ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                        document: text
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        children: description
                    }))
                ]
            }),
            url && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (OverlapCard_module_default()).badge,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: 16,
                    height: 16,
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: 2.5,
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M7 17 17 7M9 7h8v8"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var Cards_OverlapCard = (OverlapCard);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./UI/components/Cards/Card/Card.module.scss
var Card_module = __webpack_require__(93856);
var Card_module_default = /*#__PURE__*/__webpack_require__.n(Card_module);
;// CONCATENATED MODULE: ./UI/components/Cards/Card/utils/useCard.jsx








/* harmony default export */ function useCard(_param) {
    var url = _param.url, classes = _param.className, withoutBackground = _param.withoutBackground, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "url",
        "className",
        "withoutBackground"
    ]);
    var Wrapper = url ? function(props) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper/* default */.Z, (0,_object_spread/* default */.Z)({}, props));
    } : function(_param) /*#__PURE__*/ {
        var path = _param.path, className = _param.className, imagesBundles = _param.imagesBundles, restWrapper = (0,_object_without_properties/* default */.Z)(_param, [
            "path",
            "className",
            "imagesBundles"
        ]);
        return (0,jsx_runtime.jsx)(react.Fragment, (0,_object_spread/* default */.Z)({}, restWrapper));
    };
    var _obj;
    var className = classnames_default()((Card_module_default()).card, classes, (_obj = {}, (0,_define_property/* default */.Z)(_obj, (Card_module_default()).withoutBackground, withoutBackground), (0,_define_property/* default */.Z)(_obj, (Card_module_default()).withLink, url), _obj));
    return (0,_object_spread/* default */.Z)({
        Wrapper: Wrapper,
        className: className,
        withoutBackground: withoutBackground,
        path: url
    }, rest);
};

;// CONCATENATED MODULE: ./UI/components/Cards/Card/index.jsx
















var Svg = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 6778).then(__webpack_require__.bind(__webpack_require__, 6778));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6778)
            ];
        }
    },
    ssr: false
});
var getNestedCardProps = function(module) {
    if (module === null || module === void 0 ? void 0 : module.fields) {
        var ref = (0,helper/* getDocumentFields */.OA)(module, [
            "title",
            "text",
            "description",
            "images",
            "contentList",
            "contentModules",
            "subtitle", 
        ]), title = ref.title, text = ref.text, description = ref.description, images = ref.images, contentList = ref.contentList, contentModules = ref.contentModules, subtitle = ref.subtitle;
        return {
            title: title,
            text: text,
            description: description,
            image: (0,helper/* getImage */.gJ)(get_default()(images, "[0]")),
            icon: get_default()(contentList, "[0]"),
            contentModules: contentModules,
            subtitle: subtitle
        };
    }
    return (0,_object_spread/* default */.Z)({}, module);
};
var Card = function(props) {
    var _ref = useCard(props), Wrapper = _ref.Wrapper, icon = _ref.icon, title = _ref.title, text = _ref.text, children = _ref.children, className = _ref.className, image = _ref.image, withoutBackground = _ref.withoutBackground, items = _ref.items, svgWithWrapper = _ref.svgWithWrapper, contentModules = _ref.contentModules, specificCardOverlay = _ref.specificCardOverlay, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "Wrapper",
        "icon",
        "title",
        "text",
        "children",
        "className",
        "image",
        "withoutBackground",
        "items",
        "svgWithWrapper",
        "contentModules",
        "specificCardOverlay"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(CardContainer/* default */.Z, {
            className: className,
            noBackground: withoutBackground,
            children: [
                !!(image === null || image === void 0 ? void 0 : image.url) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration["default"], {
                    className: (Card_module_default()).image,
                    src: image.url,
                    alt: image.alt,
                    transparent: true
                }),
                icon && (svgWithWrapper ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Card_module_default()).iconWrapper,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                        type: icon,
                        className: (Card_module_default()).icon
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                    type: icon,
                    className: (Card_module_default()).icon
                })),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (Card_module_default()).content,
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                            variant: useTypography/* TYPOGRAPHY_TAGS.h3 */.w1.h3,
                            size: useTypography/* TYPOGRAPHY_SIZE.headline20 */.y3.headline20,
                            isBold: true,
                            className: (Card_module_default()).title,
                            children: title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (Card_module_default()).cardContent,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentfulParser["default"], {
                                    document: text
                                }),
                                !!(items === null || items === void 0 ? void 0 : items.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (Card_module_default()).itemList,
                                    children: items.map(function(item) {
                                        var ref;
                                        /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                            className: (Card_module_default()).item,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg, {
                                                    type: (ref = item.contentList) === null || ref === void 0 ? void 0 : ref[0],
                                                    className: (Card_module_default()).itemIcon
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    children: item.title
                                                })
                                            ]
                                        }, item.title);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "data-read-more": true,
                            className: (Card_module_default()).readMore,
                            children: "Read more"
                        })
                    ]
                }),
                !!(contentModules === null || contentModules === void 0 ? void 0 : contentModules.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Card_module_default()).contentModules,
                    children: contentModules.map(function(module, index) {
                        var cardProps = _extends({}, getNestedCardProps(module));
                        var key = cardProps.title || index;
                        if (specificCardOverlay) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Cards_OverlapCard, {
                                className: (Card_module_default()).overlapCard,
                                image: cardProps.image,
                                title: cardProps.title,
                                text: cardProps.text,
                                description: cardProps.description,
                                url: cardProps.subtitle
                            }, key);
                        }
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Card, (0,_object_spread/* default */.Z)({
                            className: (Card_module_default()).nestedCard
                        }, cardProps), key);
                    })
                }),
                children
            ]
        })
    }));
};
/* harmony default export */ var Cards_Card = (Card);


/***/ }),

/***/ 93812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_Illustration; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var node_modules_classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(node_modules_classnames);
// EXTERNAL MODULE: ./UI/components/Illustration/utils/helpers.js
var helpers = __webpack_require__(45783);
// EXTERNAL MODULE: ./UI/components/Illustration/styles.module.scss
var styles_module = __webpack_require__(31890);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/Illustration/utils/useIllustration.js





/* harmony default export */ function useIllustration(_param) {
    var src = _param.src, isStatic = _param.isStatic, classnames = _param.className, _lazyBoundary = _param.lazyBoundary, lazyBoundary = _lazyBoundary === void 0 ? "700px" : _lazyBoundary, apiParams = _param.apiParams, transparent = _param.transparent, placeholderProp = _param.placeholder, priority = _param.priority, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "isStatic",
        "className",
        "lazyBoundary",
        "apiParams",
        "transparent",
        "placeholder",
        "priority"
    ]);
    var loader = isStatic ? function(param) {
        var staticSrc = param.src;
        return staticSrc;
    } : function(args) {
        return (0,helpers/* getContentfulImage */.t)((0,_object_spread/* default */.Z)({
            transparent: transparent
        }, args, apiParams));
    };
    var className = classnames_default()((styles_module_default()).image, classnames);
    var lazyProps = !priority ? {
        placeholder: placeholderProp || (transparent ? "blur" : "empty"),
        blurDataURL: (0,helpers/* getContentfulImage */.t)({
            src: src,
            quality: 1,
            format: "webp",
            transparent: transparent
        })
    } : {};
    return (0,_object_spread/* default */.Z)({
        src: src,
        loader: loader,
        className: className,
        lazyBoundary: lazyBoundary,
        priority: priority
    }, lazyProps, rest);
};

;// CONCATENATED MODULE: ./UI/components/Illustration/index.jsx








var Illustration = /*#__PURE__*/ (0,react.memo)(function(props) {
    var _ref = useIllustration(props), className = _ref.className, style = _ref.style, containerClasses = _ref.containerClasses, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "className",
        "style",
        "containerClasses"
    ]);
    if (!(restProps === null || restProps === void 0 ? void 0 : restProps.src) || restProps.placeholder === "blur" && !restProps.blurDataURL) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("picture", {
        className: classnames_default()(className, containerClasses),
        style: style,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), (0,_object_spread/* default */.Z)({}, restProps))
    });
});
Illustration.defaultProps = {
    layout: "fill",
    alt: "",
    transparent: false,
    apiParams: {}
};
Illustration.propTypes = {
    transparent: (prop_types_default()).bool,
    // For more props check https://nextjs.org/docs/api-reference/next/legacy/image
    src: (prop_types_default()).string.isRequired,
    alt: (prop_types_default()).string,
    layout: prop_types_default().oneOf([
        "fill",
        "intrinsic",
        "fixed",
        "responsive", 
    ]),
    placeholder: prop_types_default().oneOf([
        "blur",
        "empty", 
    ]),
    // Check https://www.contentful.com/developers/docs/references/images-api/ for detailed api
    apiParams: prop_types_default().instanceOf(Object)
};
/* harmony default export */ var components_Illustration = (Illustration);


/***/ }),

/***/ 35565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ containers_CardContainer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/containers/CardContainer/CardContainer.module.scss
var CardContainer_module = __webpack_require__(14910);
var CardContainer_module_default = /*#__PURE__*/__webpack_require__.n(CardContainer_module);
;// CONCATENATED MODULE: ./UI/containers/CardContainer/utils/useCardContainer.js





/* harmony default export */ function useCardContainer(_param) {
    var children = _param.children, classes = _param.className, noBackground = _param.noBackground, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "className",
        "noBackground"
    ]);
    var className = classnames_default()((CardContainer_module_default()).cardContainer, classes, (0,_define_property/* default */.Z)({}, (CardContainer_module_default()).noBackground, noBackground));
    return (0,_object_spread/* default */.Z)({
        children: children,
        className: className
    }, rest);
};

;// CONCATENATED MODULE: ./UI/containers/CardContainer/index.jsx







var CardContainer = function(props, ref) {
    var _ref = useCardContainer(props), children = _ref.children, className = _ref.className, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "children",
        "className"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className,
        ref: ref
    }, restProps), {
        children: children
    }));
};
CardContainer.propTypes = {
    children: (prop_types_default()).node.isRequired,
    noBackground: (prop_types_default()).bool,
    className: (prop_types_default()).string
};
/* harmony default export */ var containers_CardContainer = (/*#__PURE__*/(0,react.forwardRef)(CardContainer));


/***/ }),

/***/ 81101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ containers_Overlay; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./UI/containers/Overlay/Overlay.module.scss
var Overlay_module = __webpack_require__(44291);
var Overlay_module_default = /*#__PURE__*/__webpack_require__.n(Overlay_module);
;// CONCATENATED MODULE: ./UI/containers/Overlay/utils/useOverlay.js




/* harmony default export */ function useOverlay(_param) {
    var classes = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    var className = classnames_default()((Overlay_module_default()).overlay, classes);
    return (0,_object_spread/* default */.Z)({
        className: className
    }, props);
};

;// CONCATENATED MODULE: ./UI/containers/Overlay/index.jsx






var Overlay = function(props) {
    var _ref = useOverlay(props), className = _ref.className, children = _ref.children, restProps = (0,_object_without_properties/* default */.Z)(_ref, [
        "className",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        className: className
    }, restProps), {
        children: children
    }));
};
Overlay.propTypes = {
    children: (prop_types_default()).node.isRequired,
    className: (prop_types_default()).string
};
/* harmony default export */ var containers_Overlay = (Overlay);


/***/ }),

/***/ 90058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_CardsSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 15 modules
var swiper_react = __webpack_require__(30719);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx
var SectionTitle = __webpack_require__(15805);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(2664);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 92 modules
var swiper_esm = __webpack_require__(44040);
// EXTERNAL MODULE: ./redux/selectors/layout.js
var layout = __webpack_require__(19341);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
// EXTERNAL MODULE: ./UI/components/Cards/Card/index.jsx + 3 modules
var Card = __webpack_require__(90704);
// EXTERNAL MODULE: ./UI/containers/Overlay/index.jsx + 1 modules
var Overlay = __webpack_require__(81101);
// EXTERNAL MODULE: ./utils/routes.js
var routes = __webpack_require__(27727);
// EXTERNAL MODULE: ./utils/constants/linkType.js
var linkType = __webpack_require__(45177);
// EXTERNAL MODULE: ./UI/sections/CardsSection/CardsSection.module.scss
var CardsSection_module = __webpack_require__(16161);
var CardsSection_module_default = /*#__PURE__*/__webpack_require__.n(CardsSection_module);
;// CONCATENATED MODULE: ./UI/sections/CardsSection/utils/useCardsSection.js

















var _obj;
var SLIDES_PER_VIEW = (_obj = {}, (0,_define_property/* default */.Z)(_obj, routes/* routes.bookCall.slug */._.bookCall.slug, {
    thirdSectionView: "auto",
    fourthSectionView: "auto"
}), (0,_define_property/* default */.Z)(_obj, constants/* CASE_STUDIES.kitchenEquipment */.qU.kitchenEquipment, {
    firstSectionView: "auto"
}), (0,_define_property/* default */.Z)(_obj, constants/* CASE_STUDIES.aiPoweredComplianceTool */.qU.aiPoweredComplianceTool, {
    firstSectionView: "auto"
}), (0,_define_property/* default */.Z)(_obj, routes/* routes.aiAgentsServices.slug */._.aiAgentsServices.slug, {
    secondSectionView: 2,
    thirdSectionView: 2
}), (0,_define_property/* default */.Z)(_obj, routes/* routes.llmDevelopment.slug */._.llmDevelopment.slug, {
    fourthSectionView: 1
}), (0,_define_property/* default */.Z)(_obj, routes/* routes.aiVoiceAssistantDevelopment.slug */._.aiVoiceAssistantDevelopment.slug, {
    fourthSectionView: 1,
    fifthSectionView: 1,
    thirdSectionView: 1
}), _obj);
var _obj1;
var SPECIFIC_SETTINGS = (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, routes/* routes.aiCopilot.slug */._.aiCopilot.slug, {
    firstSectionView: {
        breakpoints: {
            0: {
                slidesPerView: 1,
                slidesPerGroup: 1,
                centeredSlides: true
            },
            768: {
                slidesPerView: 2,
                centeredSlides: false
            },
            1024: {
                slidesPerView: 3,
                centeredSlides: false
            }
        }
    },
    secondSectionView: {
        breakpoints: {
            0: {
                slidesPerView: 1,
                slidesPerGroup: 1,
                centeredSlides: true
            }
        }
    },
    fifthSectionView: {
        breakpoints: {
            0: {
                slidesPerView: 1,
                slidesPerGroup: 1,
                centeredSlides: true
            }
        }
    },
    seventhSectionView: {
        breakpoints: {
            0: {
                slidesPerView: 1,
                slidesPerGroup: 1,
                centeredSlides: true
            }
        }
    }
}), (0,_define_property/* default */.Z)(_obj1, routes/* routes.ragDevelopment.slug */._.ragDevelopment.slug, {
    thirdSectionView: {
        breakpoints: {
            0: {
                slidesPerView: 1,
                slidesPerGroup: 1,
                centeredSlides: true
            }
        }
    }
}), _obj1);
var _obj2;
var SPACE_BETWEEN = (_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, routes/* routes.bookCall.slug */._.bookCall.slug, {
    thirdSectionView: 66,
    fourthSectionView: 43
}), (0,_define_property/* default */.Z)(_obj2, constants/* CASE_STUDIES.digitalWallet */.qU.digitalWallet, {
    firstSectionView: 16
}), (0,_define_property/* default */.Z)(_obj2, constants/* CASE_STUDIES.aiConcierge */.qU.aiConcierge, {
    firstSectionView: 16
}), (0,_define_property/* default */.Z)(_obj2, constants/* CASE_STUDIES.aiVoiceAssistant */.qU.aiVoiceAssistant, {
    firstSectionView: 16
}), _obj2);
var REWIND = (0,_define_property/* default */.Z)({}, routes/* routes.bookCall.slug */._.bookCall.slug, {
    firstSectionView: true,
    secondSectionView: true,
    thirdSectionView: true
});
var cardMapper = function(withOverlay) {
    return function(card) {
        var ref, ref1, ref2;
        if ((card === null || card === void 0 ? void 0 : (ref = card.sys) === null || ref === void 0 ? void 0 : (ref1 = ref.contentType) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sys) === null || ref2 === void 0 ? void 0 : ref2.id) === "article") {
            var ref3 = (0,helper/* getDocumentFields */.OA)(card, [
                "title",
                "previewImageUrl",
                "slug", 
            ]), title = ref3.title, previewImageUrl = ref3.previewImageUrl, slug = ref3.slug, svgWithWrapper = ref3.svgWithWrapper;
            var image = (0,helper/* getImage */.gJ)(previewImageUrl);
            return {
                url: "".concat(constants/* PAGES.blog */.q5.blog, "/").concat(slug),
                image: image,
                title: title,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Read more"
                })
            };
        }
        var _ref = (0,helper/* getDocumentFields */.OA)(card, [
            "title",
            "contentList",
            "text",
            "images",
            "imagesBundles",
            "contentModules",
            "withOverlay", 
        ]), contentList = _ref.contentList, images = _ref.images, cardContent = _ref.contentModules, text = _ref.text, title1 = _ref.title, specificCardOverlay = _ref.withOverlay, rest = (0,_object_without_properties/* default */.Z)(_ref, [
            "contentList",
            "images",
            "contentModules",
            "text",
            "title",
            "withOverlay"
        ]);
        var image1 = (0,helper/* getImage */.gJ)(get_default()(images, "[0]"));
        var icon = get_default()(contentList, "[0]");
        var url = get_default()(cardContent, "[0].fields.url");
        var modules = (cardContent || []).filter(function(item) {
            var ref, ref1, ref2;
            return (item === null || item === void 0 ? void 0 : (ref = item.sys) === null || ref === void 0 ? void 0 : (ref1 = ref.contentType) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sys) === null || ref2 === void 0 ? void 0 : ref2.id) !== "link";
        });
        var contentModules = specificCardOverlay ? modules : undefined;
        var items = specificCardOverlay ? undefined : modules.map(function(item) {
            return (0,helper/* getDocumentFields */.OA)(item, [
                "title",
                "contentList"
            ]);
        });
        var children = withOverlay ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Overlay/* default */.Z, {
            className: (CardsSection_module_default()).overlay,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Card["default"], {
                title: title1,
                text: text
            })
        }) : null;
        return (0,_object_spread/* default */.Z)({
            url: url,
            image: image1,
            icon: icon,
            text: text,
            title: title1,
            children: children,
            items: items,
            contentModules: contentModules,
            specificCardOverlay: specificCardOverlay
        }, rest);
    };
};
/* harmony default export */ function useCardsSection(_param) {
    var section = _param.section, type = _param.type, sectionWithSlider = _param.withSlider, withOverlay = _param.withOverlay, data = _param.data, handleOnCTAClickCommon = _param.handleOnCTAClick, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "section",
        "type",
        "withSlider",
        "withOverlay",
        "data",
        "handleOnCTAClick"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5;
    var ref6 = (0,helper/* getDocumentFields */.OA)(data || section, [
        "title",
        "description",
        "formattedDescription",
        "contentModules",
        "subtitle",
        "view",
        "images", 
    ], {
        isNormilized: data && !Object.keys(data).includes("fields") || section && !Object.keys(section).includes("fields")
    }), title = ref6.title, description = ref6.description, formattedDescription = ref6.formattedDescription, subtitle = ref6.subtitle, view = ref6.view, contentModules = ref6.contentModules, rawImages = ref6.images;
    var ref7 = (0,helper/* getDocumentFields */.OA)(get_default()(contentModules, "[0]", []), [
        "contentModules",
        "withoutBackground",
        "disableSliderOnMobile",
        "enableSliderOnDesktop",
        "enableSliderOnMobile",
        "svgWithWrapper", 
    ]), rawCardList = ref7.contentModules, withoutBackground = ref7.withoutBackground, disableSliderOnMobile = ref7.disableSliderOnMobile, enableSliderOnDesktop = ref7.enableSliderOnDesktop, enableSliderOnMobile = ref7.enableSliderOnMobile, svgWithWrapper = ref7.svgWithWrapper;
    var images = (rawImages || []).map(function(rawImage) {
        return (0,helper/* getImage */.gJ)(rawImage);
    });
    var cardList = (rawCardList || []).map(cardMapper(withOverlay));
    var ctaLink = get_default()(contentModules, "[1]");
    var isMobileResolution = (0,es.useSelector)(layout/* selectIsMobile */.eD);
    var isTabletResolution = (0,es.useSelector)(layout/* selectIsTablet */.aT);
    var IsFullResolution = (0,es.useSelector)(layout/* selectIsDesktop */.Y6);
    var isSmallTabletResolution = (0,es.useSelector)(layout/* selectIsSmallTablet */.Bw);
    var withSlider = sectionWithSlider || enableSliderOnDesktop || !disableSliderOnMobile && (isTabletResolution || isSmallTabletResolution || isMobileResolution) || enableSliderOnMobile && isMobileResolution;
    var isShowNavigation = enableSliderOnDesktop || !(IsFullResolution && (cardList === null || cardList === void 0 ? void 0 : cardList.length) <= 3);
    var swiperProps = (0,_object_spread/* default */.Z)({
        modules: [
            swiper_esm/* Navigation */.W_,
            swiper_esm/* Mousewheel */.Gk
        ],
        slidesPerView: 1,
        spaceBetween: ((ref = SPACE_BETWEEN[type]) === null || ref === void 0 ? void 0 : ref[view]) || 32,
        centeredSlides: true,
        autoHeight: false,
        passiveListeners: true,
        rewind: ((ref1 = REWIND[type]) === null || ref1 === void 0 ? void 0 : ref1[view]) || false,
        mousewheel: {
            forceToAxis: true
        },
        breakpoints: {
            768: {
                slidesPerView: ((ref2 = SLIDES_PER_VIEW[type]) === null || ref2 === void 0 ? void 0 : ref2[view]) || 2,
                centeredSlides: false
            },
            1024: {
                slidesPerView: ((ref3 = SLIDES_PER_VIEW[type]) === null || ref3 === void 0 ? void 0 : ref3[view]) || 3,
                centeredSlides: false
            }
        }
    }, (ref4 = SPECIFIC_SETTINGS[type]) === null || ref4 === void 0 ? void 0 : ref4[view]);
    var className = classnames_default()((CardsSection_module_default()).cardsSection, (CardsSection_module_default())[type], (CardsSection_module_default())[view], (0,_define_property/* default */.Z)({}, (CardsSection_module_default()).withSlider, withSlider));
    var handleOnCTAClick = function(e) {
        if (ctaLink.fields.type === linkType/* LINK_TYPE.scrollToSection */.x.scrollToSection) {
            e.preventDefault();
            var element = document.getElementById(ctaLink.fields.url);
            window.scrollBy({
                top: element.getBoundingClientRect().top - constants/* HEADER_HEIGHT */.Mz - 50,
                behavior: "smooth"
            });
        } else {
            handleOnCTAClickCommon();
        }
    };
    var ctaLinkData = (ctaLink === null || ctaLink === void 0 ? void 0 : (ref5 = ctaLink.fields) === null || ref5 === void 0 ? void 0 : ref5.type) === linkType/* LINK_TYPE.scrollToSection */.x.scrollToSection ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ctaLink), {
        fields: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ctaLink.fields), {
            url: ""
        })
    }) : ctaLink;
    return (0,_object_spread/* default */.Z)({
        type: type,
        view: view,
        withSlider: withSlider,
        cardList: cardList,
        ctaLink: ctaLinkData,
        title: title,
        description: description,
        formattedDescription: formattedDescription,
        subtitle: subtitle,
        className: className,
        withoutBackground: withoutBackground,
        swiperProps: swiperProps,
        withOverlay: withOverlay,
        isShowNavigation: isShowNavigation,
        images: images,
        handleOnCTAClick: handleOnCTAClick,
        svgWithWrapper: svgWithWrapper
    }, rest);
};

;// CONCATENATED MODULE: ./UI/sections/CardsSection/index.jsx












var CardsSection_Card = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 90704));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90704)
            ];
        }
    }
});
var CallToAction = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 31566).then(__webpack_require__.bind(__webpack_require__, 49617));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(49617)
            ];
        }
    }
});
var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var Illustration = dynamic_default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 93812));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(93812)
            ];
        }
    }
});
var CustomSwiper = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 33051).then(__webpack_require__.bind(__webpack_require__, 33051));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33051)
            ];
        }
    },
    ssr: false
});
var CardsSection = function(props) {
    var ref = useCardsSection(props), title = ref.title, subtitle = ref.subtitle, description = ref.description, cardList = ref.cardList, ctaLink = ref.ctaLink, withSlider = ref.withSlider, className = ref.className, handleOnCTAClick = ref.handleOnCTAClick, withoutBackground = ref.withoutBackground, withOverlay = ref.withOverlay, swiperProps = ref.swiperProps, isShowNavigation = ref.isShowNavigation, images = ref.images, type = ref.type, svgWithWrapper = ref.svgWithWrapper, formattedDescription = ref.formattedDescription;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (CardsSection_module_default()).contentWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                    title: title,
                    subtitle: subtitle,
                    description: description,
                    formattedDescription: formattedDescription,
                    className: (CardsSection_module_default()).title
                }),
                withSlider && /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomSwiper, {
                    className: (CardsSection_module_default()).swiperList,
                    swiperParams: swiperProps,
                    isShowNavigation: isShowNavigation,
                    navigationClassName: (CardsSection_module_default()).navigation,
                    children: cardList.map(function(card, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsSection_Card, (0,_object_spread/* default */.Z)({
                                className: classnames_default()((CardsSection_module_default()).card, (CardsSection_module_default())["card-".concat(i + 1)]),
                                withoutBackground: withoutBackground,
                                svgWithWrapper: svgWithWrapper
                            }, card))
                        }, i);
                    })
                }),
                !withSlider && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (CardsSection_module_default()).cardList,
                    children: cardList.map(function(card, i) {
                        return /*#__PURE__*/ (0,react.createElement)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                            delay: 50 * i,
                            key: "card/".concat(i)
                        }), /*#__PURE__*/ (0,jsx_runtime.jsx)(CardsSection_Card, (0,_object_spread/* default */.Z)({
                            className: classnames_default()((CardsSection_module_default()).card, (CardsSection_module_default())["card-".concat(i + 1)], (0,_define_property/* default */.Z)({}, (CardsSection_module_default()).withOverlay, withOverlay)),
                            withoutBackground: withoutBackground,
                            svgWithWrapper: svgWithWrapper
                        }, card), i));
                    })
                }),
                !!images.length && images.map(function(image) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Illustration, {
                        src: image.url,
                        className: (CardsSection_module_default()).image
                    }, image.url);
                }),
                ctaLink && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                    transitionDelay: 50,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CallToAction, {
                        data: ctaLink,
                        handleOnClick: handleOnCTAClick,
                        className: (CardsSection_module_default()).callToAction,
                        pageType: type
                    })
                }))
            ]
        })
    });
};
/* harmony default export */ var sections_CardsSection = (CardsSection);


/***/ }),

/***/ 45177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ LINK_TYPE; }
/* harmony export */ });
var LINK_TYPE = {
    bookmark: "bookmark",
    callToAction: "call-to-action",
    button: "button",
    youTube: "youtube-video",
    book: "book",
    subscribe: "subscribe",
    scrollBlock: "scroll-block",
    scrollTop: "scroll-top",
    scrollToSection: "scroll-to-section",
    download: "download"
};


/***/ }),

/***/ 93856:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__msYo3","image":"Card_image__lDcsK","withoutBackground":"Card_withoutBackground__W7fGZ","title":"Card_title__3oNoL","withLink":"Card_withLink__QI1Gl","icon":"Card_icon__bKpvu","content":"Card_content__amq2q","cardContent":"Card_cardContent__g4BWE","itemList":"Card_itemList__3_kfl","item":"Card_item__hpzdo","itemIcon":"Card_itemIcon__3IkSz","contentModules":"Card_contentModules__yQFYp","nestedCard":"Card_nestedCard__gVsGc","overlapCard":"Card_overlapCard__fgfJv"};

/***/ }),

/***/ 42070:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlapCard":"OverlapCard_overlapCard__ZjLrZ","image":"OverlapCard_image__216M_","overlay":"OverlapCard_overlay__s_4Gv","badge":"OverlapCard_badge__QQrWF"};

/***/ }),

/***/ 31890:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"image":"styles_image__T17hn"};

/***/ }),

/***/ 14910:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"CardContainer_cardContainer__GnP7H","noBackground":"CardContainer_noBackground__jHEZf","sb_cardWithOverlay":"CardContainer_sb_cardWithOverlay__guDiR","overlay":"CardContainer_overlay__xSItN"};

/***/ }),

/***/ 44291:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay_overlay__5DSjH"};

/***/ }),

/***/ 16161:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardsWithFullWidthImage":"CardsSection_cardsWithFullWidthImage__zdiiy","cards":"CardsSection_cards__Xu1aj","imageWrapper":"CardsSection_imageWrapper__E14c7","typeTitle":"CardsSection_typeTitle__umrvG","greySection":"CardsSection_greySection__VPrk_","mlops-development-services":"CardsSection_mlops-development-services__uzy4n","thirdSectionView":"CardsSection_thirdSectionView__VDnBT","software-development-engagement-models":"CardsSection_software-development-engagement-models__iOuI4","firstSectionView":"CardsSection_firstSectionView__4VK2e","natural-language-processing-as-a-service":"CardsSection_natural-language-processing-as-a-service__zSp2l","fourthSectionView":"CardsSection_fourthSectionView__QyB8v","ai-consulting-services":"CardsSection_ai-consulting-services__ijFzE","deep-learning":"CardsSection_deep-learning__BL3fw","sixthSectionView":"CardsSection_sixthSectionView__2aRkm","generative-ai-services":"CardsSection_generative-ai-services__k_Jl8","book-a-call":"CardsSection_book-a-call__P_xEY","billing-software-development-services":"CardsSection_billing-software-development-services__pH_Ua","secondSectionView":"CardsSection_secondSectionView__nVuyi","software-quality-assurance-services":"CardsSection_software-quality-assurance-services__ojOoL","seventhSectionView":"CardsSection_seventhSectionView__ommtO","fifthSectionView":"CardsSection_fifthSectionView__CmnNj","payment-gateway-development-company":"CardsSection_payment-gateway-development-company__U0yuY","crowdfunding-platform-development-company":"CardsSection_crowdfunding-platform-development-company__H7mA8","penetration-testing":"CardsSection_penetration-testing__OPuIw","trading-software-development":"CardsSection_trading-software-development__PqfXN","lending-software-development":"CardsSection_lending-software-development__NToNB","prototyping-services":"CardsSection_prototyping-services__7RMgf","cross-platform-development-services":"CardsSection_cross-platform-development-services__RK6T4","cardsSection":"CardsSection_cardsSection__4tbF6","data-science-development-company":"CardsSection_data-science-development-company__RTwc9","web-app-development-company":"CardsSection_web-app-development-company__hV7id","ui-ux-services":"CardsSection_ui-ux-services__aosV_","mvp-app-development-company":"CardsSection_mvp-app-development-company__7f6yC","mobile-app-development-company":"CardsSection_mobile-app-development-company__MAChc","machine-learning-development-services":"CardsSection_machine-learning-development-services__TNMF_","ios-mobile-app-development-services":"CardsSection_ios-mobile-app-development-services__7G_Sl","fintech-software-development-services":"CardsSection_fintech-software-development-services__NPmkl","enterprise-resource-planning-software-services":"CardsSection_enterprise-resource-planning-software-services__UvLz7","discovery-phase-services":"CardsSection_discovery-phase-services__q7eTt","devops-development-services":"CardsSection_devops-development-services__xsFZn","cloud-based-app-development-services":"CardsSection_cloud-based-app-development-services__wit78","chat-app-development-company":"CardsSection_chat-app-development-company__Z_bop","artificial-intelligence-development-services":"CardsSection_artificial-intelligence-development-services__lIgpX","android-mobile-app-development-services":"CardsSection_android-mobile-app-development-services__G_iyX","callToAction":"CardsSection_callToAction__7jwDj","threeColumnsCards":"CardsSection_threeColumnsCards__iVFfi","ai-voice-assistant-development-services":"CardsSection_ai-voice-assistant-development-services__nVGFt","cardList":"CardsSection_cardList__RfzYT","llm-development-services":"CardsSection_llm-development-services__73RA2","eighthSectionView":"CardsSection_eighthSectionView__vsF_M","ai-agent-development-services":"CardsSection_ai-agent-development-services__1fSd2","healthcare-software-development-services":"CardsSection_healthcare-software-development-services__wPpT_","entertainment-software-development-services":"CardsSection_entertainment-software-development-services__d8qpQ","educational-software-development-services":"CardsSection_educational-software-development-services__dR8Ao","travel-and-hospitality-software-development":"CardsSection_travel-and-hospitality-software-development__SBRqC","robotic-process-automation-services":"CardsSection_robotic-process-automation-services__TCa46","ai-staff-augmentation-services":"CardsSection_ai-staff-augmentation-services__pORqg","e-commerce-development":"CardsSection_e-commerce-development__Cx8Uf","logistics-software-development-services":"CardsSection_logistics-software-development-services__PG2Oc","software-development-services-for-various-industries":"CardsSection_software-development-services-for-various-industries__BmonE","software-development-services-for-tech-businesses":"CardsSection_software-development-services-for-tech-businesses__at2Qd","computer-vision-services":"CardsSection_computer-vision-services__GqD6w","digital-wallet-for-ios":"CardsSection_digital-wallet-for-ios__AqUPb","clairvoyant-directory-upgrade":"CardsSection_clairvoyant-directory-upgrade__VxjGC","software-development-columbus":"CardsSection_software-development-columbus__JteBr","software-development-new-orleans":"CardsSection_software-development-new-orleans__x3fRz","software-development-tulsa":"CardsSection_software-development-tulsa__RLB3i","software-development-miami":"CardsSection_software-development-miami__FpOOu","software-development-minneapolis":"CardsSection_software-development-minneapolis__ENGlQ","software-development-omaha":"CardsSection_software-development-omaha__3gdbd","software-development-washington":"CardsSection_software-development-washington__Egyr1","software-development-oklahoma":"CardsSection_software-development-oklahoma__9r_Qz","software-development-nashville":"CardsSection_software-development-nashville__OWpgb","software-development-raleigh":"CardsSection_software-development-raleigh__N8n8v","crowdfunding-platform":"CardsSection_crowdfunding-platform__lmsT_","mobile-bank-application":"CardsSection_mobile-bank-application__Pz5fs","banking-software-development-company":"CardsSection_banking-software-development-company__A2tE9","e-wallet-app-development":"CardsSection_e-wallet-app-development__rAHtO","pricing":"CardsSection_pricing__K4dox","twoColumnsCards":"CardsSection_twoColumnsCards__PWq94","ai-managed-pod":"CardsSection_ai-managed-pod__WeQhD","rag-development-services":"CardsSection_rag-development-services__9BA5B","ai-copilot-development-services":"CardsSection_ai-copilot-development-services__owik4","david-vs-goliath":"CardsSection_david-vs-goliath__gOuSV","textContent":"CardsSection_textContent__os1cn","cardWithFullSizeImage":"CardsSection_cardWithFullSizeImage__VDwQF","card":"CardsSection_card__CPc_I","beyond-chatbots-webinar":"CardsSection_beyond-chatbots-webinar__hzeZj","llm-use-cases-webinar":"CardsSection_llm-use-cases-webinar__DcGgj","beyond-the-hype":"CardsSection_beyond-the-hype__u1UMc","blackSection":"CardsSection_blackSection__OvRHP","title":"CardsSection_title__WS_CJ","cardWithVerticalLine":"CardsSection_cardWithVerticalLine__ePRFX","overlay":"CardsSection_overlay__ekBI0","withOverlay":"CardsSection_withOverlay__GfGjt","contentWrapper":"CardsSection_contentWrapper__cfk_V","cardWithTransperentBackground":"CardsSection_cardWithTransperentBackground___W6E_","assessmentCta":"CardsSection_assessmentCta__NI6Cb","ai-chatbot-development-services":"CardsSection_ai-chatbot-development-services__oaP2l","card-1":"CardsSection_card-1__PNsBd","card-2":"CardsSection_card-2__udl4d","card-3":"CardsSection_card-3__nusab","card-4":"CardsSection_card-4__sLdpk","software-development-services-for-startups":"CardsSection_software-development-services-for-startups__2FQnW","cardContent":"CardsSection_cardContent__SL1Y3","navigation":"CardsSection_navigation__NyjAb","newhomepage":"CardsSection_newhomepage__O_0jZ","content":"CardsSection_content__oYPR0","swiper":"CardsSection_swiper__SK_5H","delivery-quality-in-yellow":"CardsSection_delivery-quality-in-yellow__Ci7eh","pwa-development-services":"CardsSection_pwa-development-services__Ug2rS","image":"CardsSection_image__s_aFw","company":"CardsSection_company__bp8ap","kitchen-equipment-customizer":"CardsSection_kitchen-equipment-customizer__Qm3wI","ai-software-development-services":"CardsSection_ai-software-development-services__tw3MO","ai-mobile-cooking-app":"CardsSection_ai-mobile-cooking-app___oTD2","card-5":"CardsSection_card-5__kT_Bo","card-6":"CardsSection_card-6__gn2pK","ai-based-travel-planner":"CardsSection_ai-based-travel-planner__0I_mz","enhancing-money-laundering-mention-extraction":"CardsSection_enhancing-money-laundering-mention-extraction__8GfKS","ai-concierge-for-hotel-network":"CardsSection_ai-concierge-for-hotel-network__JMzjD","ai-voice-assistant-for-e-learning":"CardsSection_ai-voice-assistant-for-e-learning__Pnuws","card-7":"CardsSection_card-7__gUGyn","card-8":"CardsSection_card-8__YvEsC","ai-assistant-for-chronic-patients":"CardsSection_ai-assistant-for-chronic-patients__zpOv_","services":"CardsSection_services__2sTaS","ai-warehouse-agent":"CardsSection_ai-warehouse-agent__mf4io","rag-contract-intelligence-platform":"CardsSection_rag-contract-intelligence-platform__8ixcy","dmitry":"CardsSection_dmitry__NKK1j","vlad":"CardsSection_vlad___zMUU","sofia":"CardsSection_sofia__P4CZ7","mikita":"CardsSection_mikita__FTcdM","yana":"CardsSection_yana__hA_Ew","lika":"CardsSection_lika__KYk9A","nastassia":"CardsSection_nastassia__m2pJB","claude-sonnet-leasing-operations-platform":"CardsSection_claude-sonnet-leasing-operations-platform__eUaTD","ai-assessments":"CardsSection_ai-assessments__j0Tyg"};

/***/ }),

/***/ 31304:
/***/ (function(module) {


;(function (name, root, factory) {
  if (true) {
    module.exports = factory()
    module.exports["default"] = factory()
  }
  /* istanbul ignore next */
  else {}
}('slugify', this, function () {
  var charMap = JSON.parse('{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","¢":"cent","£":"pound","¤":"currency","¥":"yen","©":"(c)","ª":"a","®":"(r)","º":"o","À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","Æ":"AE","Ç":"C","È":"E","É":"E","Ê":"E","Ë":"E","Ì":"I","Í":"I","Î":"I","Ï":"I","Ð":"D","Ñ":"N","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","Ù":"U","Ú":"U","Û":"U","Ü":"U","Ý":"Y","Þ":"TH","ß":"ss","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","æ":"ae","ç":"c","è":"e","é":"e","ê":"e","ë":"e","ì":"i","í":"i","î":"i","ï":"i","ð":"d","ñ":"n","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","ù":"u","ú":"u","û":"u","ü":"u","ý":"y","þ":"th","ÿ":"y","Ā":"A","ā":"a","Ă":"A","ă":"a","Ą":"A","ą":"a","Ć":"C","ć":"c","Č":"C","č":"c","Ď":"D","ď":"d","Đ":"DJ","đ":"dj","Ē":"E","ē":"e","Ė":"E","ė":"e","Ę":"e","ę":"e","Ě":"E","ě":"e","Ğ":"G","ğ":"g","Ģ":"G","ģ":"g","Ĩ":"I","ĩ":"i","Ī":"i","ī":"i","Į":"I","į":"i","İ":"I","ı":"i","Ķ":"k","ķ":"k","Ļ":"L","ļ":"l","Ľ":"L","ľ":"l","Ł":"L","ł":"l","Ń":"N","ń":"n","Ņ":"N","ņ":"n","Ň":"N","ň":"n","Ō":"O","ō":"o","Ő":"O","ő":"o","Œ":"OE","œ":"oe","Ŕ":"R","ŕ":"r","Ř":"R","ř":"r","Ś":"S","ś":"s","Ş":"S","ş":"s","Š":"S","š":"s","Ţ":"T","ţ":"t","Ť":"T","ť":"t","Ũ":"U","ũ":"u","Ū":"u","ū":"u","Ů":"U","ů":"u","Ű":"U","ű":"u","Ų":"U","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","ź":"z","Ż":"Z","ż":"z","Ž":"Z","ž":"z","Ə":"E","ƒ":"f","Ơ":"O","ơ":"o","Ư":"U","ư":"u","ǈ":"LJ","ǉ":"lj","ǋ":"NJ","ǌ":"nj","Ș":"S","ș":"s","Ț":"T","ț":"t","ə":"e","˚":"o","Ά":"A","Έ":"E","Ή":"H","Ί":"I","Ό":"O","Ύ":"Y","Ώ":"W","ΐ":"i","Α":"A","Β":"B","Γ":"G","Δ":"D","Ε":"E","Ζ":"Z","Η":"H","Θ":"8","Ι":"I","Κ":"K","Λ":"L","Μ":"M","Ν":"N","Ξ":"3","Ο":"O","Π":"P","Ρ":"R","Σ":"S","Τ":"T","Υ":"Y","Φ":"F","Χ":"X","Ψ":"PS","Ω":"W","Ϊ":"I","Ϋ":"Y","ά":"a","έ":"e","ή":"h","ί":"i","ΰ":"y","α":"a","β":"b","γ":"g","δ":"d","ε":"e","ζ":"z","η":"h","θ":"8","ι":"i","κ":"k","λ":"l","μ":"m","ν":"n","ξ":"3","ο":"o","π":"p","ρ":"r","ς":"s","σ":"s","τ":"t","υ":"y","φ":"f","χ":"x","ψ":"ps","ω":"w","ϊ":"i","ϋ":"y","ό":"o","ύ":"y","ώ":"w","Ё":"Yo","Ђ":"DJ","Є":"Ye","І":"I","Ї":"Yi","Ј":"J","Љ":"LJ","Њ":"NJ","Ћ":"C","Џ":"DZ","А":"A","Б":"B","В":"V","Г":"G","Д":"D","Е":"E","Ж":"Zh","З":"Z","И":"I","Й":"J","К":"K","Л":"L","М":"M","Н":"N","О":"O","П":"P","Р":"R","С":"S","Т":"T","У":"U","Ф":"F","Х":"H","Ц":"C","Ч":"Ch","Ш":"Sh","Щ":"Sh","Ъ":"U","Ы":"Y","Ь":"","Э":"E","Ю":"Yu","Я":"Ya","а":"a","б":"b","в":"v","г":"g","д":"d","е":"e","ж":"zh","з":"z","и":"i","й":"j","к":"k","л":"l","м":"m","н":"n","о":"o","п":"p","р":"r","с":"s","т":"t","у":"u","ф":"f","х":"h","ц":"c","ч":"ch","ш":"sh","щ":"sh","ъ":"u","ы":"y","ь":"","э":"e","ю":"yu","я":"ya","ё":"yo","ђ":"dj","є":"ye","і":"i","ї":"yi","ј":"j","љ":"lj","њ":"nj","ћ":"c","ѝ":"u","џ":"dz","Ґ":"G","ґ":"g","Ғ":"GH","ғ":"gh","Қ":"KH","қ":"kh","Ң":"NG","ң":"ng","Ү":"UE","ү":"ue","Ұ":"U","ұ":"u","Һ":"H","һ":"h","Ә":"AE","ә":"ae","Ө":"OE","ө":"oe","Ա":"A","Բ":"B","Գ":"G","Դ":"D","Ե":"E","Զ":"Z","Է":"E\'","Ը":"Y\'","Թ":"T\'","Ժ":"JH","Ի":"I","Լ":"L","Խ":"X","Ծ":"C\'","Կ":"K","Հ":"H","Ձ":"D\'","Ղ":"GH","Ճ":"TW","Մ":"M","Յ":"Y","Ն":"N","Շ":"SH","Չ":"CH","Պ":"P","Ջ":"J","Ռ":"R\'","Ս":"S","Վ":"V","Տ":"T","Ր":"R","Ց":"C","Փ":"P\'","Ք":"Q\'","Օ":"O\'\'","Ֆ":"F","և":"EV","ء":"a","آ":"aa","أ":"a","ؤ":"u","إ":"i","ئ":"e","ا":"a","ب":"b","ة":"h","ت":"t","ث":"th","ج":"j","ح":"h","خ":"kh","د":"d","ذ":"th","ر":"r","ز":"z","س":"s","ش":"sh","ص":"s","ض":"dh","ط":"t","ظ":"z","ع":"a","غ":"gh","ف":"f","ق":"q","ك":"k","ل":"l","م":"m","ن":"n","ه":"h","و":"w","ى":"a","ي":"y","ً":"an","ٌ":"on","ٍ":"en","َ":"a","ُ":"u","ِ":"e","ْ":"","٠":"0","١":"1","٢":"2","٣":"3","٤":"4","٥":"5","٦":"6","٧":"7","٨":"8","٩":"9","پ":"p","چ":"ch","ژ":"zh","ک":"k","گ":"g","ی":"y","۰":"0","۱":"1","۲":"2","۳":"3","۴":"4","۵":"5","۶":"6","۷":"7","۸":"8","۹":"9","฿":"baht","ა":"a","ბ":"b","გ":"g","დ":"d","ე":"e","ვ":"v","ზ":"z","თ":"t","ი":"i","კ":"k","ლ":"l","მ":"m","ნ":"n","ო":"o","პ":"p","ჟ":"zh","რ":"r","ს":"s","ტ":"t","უ":"u","ფ":"f","ქ":"k","ღ":"gh","ყ":"q","შ":"sh","ჩ":"ch","ც":"ts","ძ":"dz","წ":"ts","ჭ":"ch","ხ":"kh","ჯ":"j","ჰ":"h","Ṣ":"S","ṣ":"s","Ẁ":"W","ẁ":"w","Ẃ":"W","ẃ":"w","Ẅ":"W","ẅ":"w","ẞ":"SS","Ạ":"A","ạ":"a","Ả":"A","ả":"a","Ấ":"A","ấ":"a","Ầ":"A","ầ":"a","Ẩ":"A","ẩ":"a","Ẫ":"A","ẫ":"a","Ậ":"A","ậ":"a","Ắ":"A","ắ":"a","Ằ":"A","ằ":"a","Ẳ":"A","ẳ":"a","Ẵ":"A","ẵ":"a","Ặ":"A","ặ":"a","Ẹ":"E","ẹ":"e","Ẻ":"E","ẻ":"e","Ẽ":"E","ẽ":"e","Ế":"E","ế":"e","Ề":"E","ề":"e","Ể":"E","ể":"e","Ễ":"E","ễ":"e","Ệ":"E","ệ":"e","Ỉ":"I","ỉ":"i","Ị":"I","ị":"i","Ọ":"O","ọ":"o","Ỏ":"O","ỏ":"o","Ố":"O","ố":"o","Ồ":"O","ồ":"o","Ổ":"O","ổ":"o","Ỗ":"O","ỗ":"o","Ộ":"O","ộ":"o","Ớ":"O","ớ":"o","Ờ":"O","ờ":"o","Ở":"O","ở":"o","Ỡ":"O","ỡ":"o","Ợ":"O","ợ":"o","Ụ":"U","ụ":"u","Ủ":"U","ủ":"u","Ứ":"U","ứ":"u","Ừ":"U","ừ":"u","Ử":"U","ử":"u","Ữ":"U","ữ":"u","Ự":"U","ự":"u","Ỳ":"Y","ỳ":"y","Ỵ":"Y","ỵ":"y","Ỷ":"Y","ỷ":"y","Ỹ":"Y","ỹ":"y","–":"-","‘":"\'","’":"\'","“":"\\\"","”":"\\\"","„":"\\\"","†":"+","•":"*","…":"...","₠":"ecu","₢":"cruzeiro","₣":"french franc","₤":"lira","₥":"mill","₦":"naira","₧":"peseta","₨":"rupee","₩":"won","₪":"new shequel","₫":"dong","€":"euro","₭":"kip","₮":"tugrik","₯":"drachma","₰":"penny","₱":"peso","₲":"guarani","₳":"austral","₴":"hryvnia","₵":"cedi","₸":"kazakhstani tenge","₹":"indian rupee","₺":"turkish lira","₽":"russian ruble","₿":"bitcoin","℠":"sm","™":"tm","∂":"d","∆":"delta","∑":"sum","∞":"infinity","♥":"love","元":"yuan","円":"yen","﷼":"rial","ﻵ":"laa","ﻷ":"laa","ﻹ":"lai","ﻻ":"la"}')
  var locales = JSON.parse('{"bg":{"Й":"Y","Ц":"Ts","Щ":"Sht","Ъ":"A","Ь":"Y","й":"y","ц":"ts","щ":"sht","ъ":"a","ь":"y"},"de":{"Ä":"AE","ä":"ae","Ö":"OE","ö":"oe","Ü":"UE","ü":"ue","ß":"ss","%":"prozent","&":"und","|":"oder","∑":"summe","∞":"unendlich","♥":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","¢":"centavos","£":"libras","¤":"moneda","₣":"francos","∑":"suma","∞":"infinito","♥":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","¢":"centime","£":"livre","¤":"devise","₣":"franc","∑":"somme","∞":"infini","♥":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","¢":"centavo","∑":"soma","£":"libra","∞":"infinito","♥":"amor"},"uk":{"И":"Y","и":"y","Й":"Y","й":"y","Ц":"Ts","ц":"ts","Х":"Kh","х":"kh","Щ":"Shch","щ":"shch","Г":"H","г":"h"},"vi":{"Đ":"D","đ":"d"},"da":{"Ø":"OE","ø":"oe","Å":"AA","å":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"større end"},"nb":{"&":"og","Å":"AA","Æ":"AE","Ø":"OE","å":"aa","æ":"ae","ø":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","Å":"AA","Ä":"AE","Ö":"OE","å":"aa","ä":"ae","ö":"oe"}}')

  function replace (string, options) {
    if (typeof string !== 'string') {
      throw new Error('slugify: string argument expected')
    }

    options = (typeof options === 'string')
      ? {replacement: options}
      : options || {}

    var locale = locales[options.locale] || {}

    var replacement = options.replacement === undefined ? '-' : options.replacement

    var trim = options.trim === undefined ? true : options.trim

    var slug = string.normalize().split('')
      // replace characters based on charMap
      .reduce(function (result, ch) {
        var appendChar = locale[ch];
        if (appendChar === undefined) appendChar = charMap[ch];
        if (appendChar === undefined) appendChar = ch;
        if (appendChar === replacement) appendChar = ' ';
        return result + appendChar
          // remove not allowed characters
          .replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, '')
      }, '');

    if (options.strict) {
      slug = slug.replace(/[^A-Za-z0-9\s]/g, '');
    }

    if (trim) {
      slug = slug.trim()
    }

    // Replace spaces with replacement character, treating multiple consecutive
    // spaces as a single space.
    slug = slug.replace(/\s+/g, replacement);

    if (options.lower) {
      slug = slug.toLowerCase()
    }

    return slug
  }

  replace.extend = function (customMap) {
    Object.assign(charMap, customMap)
  }

  return replace
}))


/***/ })

}]);